export const MY_SKILLS = [
  {
    title: "Frontend Technologies",
    subtitle: "Develop Web Applications",
    skills: [
      {
        name: "HTML",
        percentage: "90",
        id: "html",
      },
      {
        name: "CSS",
        percentage: "80",
        id: "css",
      },
      {
        name: "Javascript",
        percentage: "85",
        id: "javascript",
      },
      {
        name: "ReactJs",
        percentage: "90",
        id: "reactjs",
      },
      {
        name: "Angular 2+",
        percentage: "75",
        id: "angular",
      },
      {
        name: "VueJs",
        percentage: "60",
        id: "vuejs",
      },
    ],
  },
  {
    title: "Computer Science",
    subtitle: "Efficiency in action",
    skills: [
      {
        name: "Data Structures",
        percentage: "85",
        id: "datastructures",
      },
      {
        name: "Algorithms",
        percentage: "80",
        id: "algorithms",
      },
      {
        name: "Git",
        percentage: "75",
        id: "git",
      },
    ],
  },
];
